import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import { observer } from 'mobx-react'
import moment from 'moment'
import React from 'react'
import DataUnit from '../../../../../components/customElements/DataUnit/DataUnit'
import FormInput from '../../../../../components/customElements/FormInput'
import CustomAccordion from '../../../../../components/customElements/RequestDataAccordions/utils/CustomAccordion'
import {
  isAdministration,
  isOperator,
} from '../../../../../services/AccountService'
import { openModalFn } from '../../../../../utils/controllers/ModalController'
import AddPhotosBlock from './AddPhotosBlock'
import {
  forbiddenPhotoStatuses,
  useServiceInformationAccordion,
} from './useServiceInformationAccordion'

const ServiceInformationAccordion = ({
  serviceStore,
  type,
  preventUploadPics,
  children,
  isCompleteDrawer,
  isToGuaranteeType = false,
}) => {
  const {
    canEditSubscriberData,
    handleEdit,
    intl,
    collection,
    shouldGetModelInfo,
    receiveresModels,
    currentServiceData,
    serviceInformationAccordionFormStore,
    pictures,
  } = useServiceInformationAccordion(serviceStore, type)

  const allPictures = pictures.reduce(
    (prev, pictureItem) => {
      return {
        ...prev,
        list: [...prev.list, ...pictureItem.list],
        urls: [...prev.urls, ...pictureItem.urls],
      }
    },
    {
      name: '',
      list: [],
      urls: [],
    },
  )

  const canAddPics =
    !forbiddenPhotoStatuses.includes(currentServiceData.status) &&
    !preventUploadPics

  return (
    <CustomAccordion
      summary={
        type === 2 ? 'Передача в сервисный центр' : 'Информация об обслуживании'
      }
      defaultOpenState={true}
      preventHandleOpen={false}
      onEdit={canEditSubscriberData && !isOperator() && handleEdit}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '14px',
          marginTop: '12px',
          paddingLeft: '15px',
        }}
      >
        {!isToGuaranteeType && (
          <>
            {currentServiceData.dateOfMaintenance ||
            currentServiceData.dateOfSeizure ? (
              <>
                <DataUnit
                  name={
                    type === 2
                      ? intl.formatMessage({ id: 'Дата изъятия оборудования' })
                      : intl.formatMessage({ id: 'Дата выполнения работ' })
                  }
                  value={
                    type === 2
                      ? moment(currentServiceData.dateOfSeizure).format(
                          'DD.MM.YYYY',
                        )
                      : moment(currentServiceData.dateOfMaintenance).format(
                          'DD.MM.YYYY',
                        )
                  }
                />
                <DataUnit
                  name={intl.formatMessage({ id: 'Описание работ' })}
                  value={currentServiceData?.workDescription ?? '-'}
                />
              </>
            ) : (
              <FormInput
                api={serviceInformationAccordionFormStore}
                type={'text'}
                propName={'dateOfMaintenance'}
                fullWidth
                mask={'99-99-9999'}
                label={
                  type === 2
                    ? intl.formatMessage({ id: 'Дата изъятия оборудования' })
                    : intl.formatMessage({ id: 'Дата выполнения работ' })
                }
                withoutErrorText={true}
                defaultValue={
                  type === 2
                    ? currentServiceData.dateOfSeizure
                      ? moment(currentServiceData.dateOfSeizure).format(
                          'DD.MM.YYYY',
                        )
                      : moment().format('DD.MM.YYYY')
                    : currentServiceData.dateOfMaintenance
                      ? moment(currentServiceData.dateOfMaintenance).format(
                          'DD.MM.YYYY',
                        )
                      : moment().format('DD.MM.YYYY')
                }
              />
            )}
          </>
        )}
        {isToGuaranteeType && currentServiceData?.status === 5 && (
          <FormInput
            api={serviceInformationAccordionFormStore}
            type={'text'}
            propName={'dateOfVisit'}
            fullWidth
            mask={'99-99-9999'}
            label={intl.formatMessage({ id: 'Дата обслуживания' })}
            withoutErrorText={true}
            defaultValue={
              currentServiceData.dateOfVisit
                ? moment(currentServiceData.dateOfVisit).format('DD.MM.YYYY')
                : moment().format('DD.MM.YYYY')
            }
          />
        )}
        {children}
        {!isOperator() && !isAdministration() && (
          <>
            {allPictures.urls?.length && !isCompleteDrawer ? (
              <Box>
                <Typography
                  variant={'body2'}
                  color={'grey.500'}
                  sx={{ marginY: '4px', lineHeight: 1 }}
                >
                  Фото
                </Typography>
                <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                  {allPictures.urls?.map((url, i) => {
                    return (
                      <img
                        key={url}
                        style={{
                          width: '64px',
                          height: '64px',
                          borderRadius: '8px',
                          border: '1px solid gray',
                          cursor: 'pointer',
                        }}
                        src={url}
                        onClick={() => {
                          openModalFn['photo-gallery']({
                            collection: allPictures.list,
                            initialIndex: i,
                            name: 'Фото',
                          })
                        }}
                      />
                    )
                  })}
                </Box>
              </Box>
            ) : (
              canAddPics && (
                <AddPhotosBlock
                  settingsField={'MaintenanceCompleted'}
                  formStore={serviceInformationAccordionFormStore}
                  serviceStore={serviceStore}
                />
              )
            )}
          </>
        )}

        {type === 2 &&
          (currentServiceData.diagnosticPassBasisComment ? (
            <DataUnit
              name={intl.formatMessage({
                id: 'Основание для передачи в сервисный центр',
              })}
              value={currentServiceData.diagnosticPassBasisComment}
            />
          ) : (
            <FormInput
              api={serviceInformationAccordionFormStore}
              type={'text'}
              propName={'diagnosticPassBasisComment'}
              fullWidth
              label={intl.formatMessage({
                id: 'Основание для передачи в сервисный центр',
              })}
              withoutErrorText={true}
              minRows={3}
              multiline
            />
          ))}
      </Box>
    </CustomAccordion>
  )
}

export const validateNumberInput = (event) => {
  return /^[0-9]+$/.test(event.target.value) || event.target.value === ''
}

export default observer(ServiceInformationAccordion)
